module.exports = __webpack_public_path__ + "img/zb1.ae6959b4.png";